(function () {
  function sync() {
    var outer = document.querySelector('.perks-strip__outer[data-hide-on-onetime]');
    if (!outer) return;
    var onetime = document.querySelector('.loop-widget-purchase-option-onetime');
    var isOnetimeSelected = !!onetime && onetime.classList.contains('loop-widget-purchase-option-selected');
    outer.hidden = isOnetimeSelected;
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.loop-widget-purchase-option')) {
      setTimeout(sync, 50);
    }
  });

  var bodyObserver = new MutationObserver(function () {
    sync();
    if (document.querySelector('.loop-widget-purchase-option-onetime')) {
      var classObserver = new MutationObserver(sync);
      classObserver.observe(document.querySelector('.loop-widget-purchase-options-container'), {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
      bodyObserver.disconnect();
    }
  });
  bodyObserver.observe(document.body, { subtree: true, childList: true });

  sync();
})();
